import { render, staticRenderFns } from "./ContactActionNotesItem.vue?vue&type=template&id=1a3fb116&scoped=true&"
import script from "./ContactActionNotesItem.vue?vue&type=script&lang=js&"
export * from "./ContactActionNotesItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionNotesItem.vue?vue&type=style&index=0&id=1a3fb116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3fb116",
  null
  
)

export default component.exports